/*
* Broadcast Theme - Sylnia Butik
*
* Eigen JavaScript. Wordt geladen vanuit layout/theme.liquid.
* Bewerk theme.js NOOIT rechtstreeks; zet aanpassingen hier.
*/

(function () {
  // Add custom code below this line

  /* ------------------------------------------------------------------
     Hoofdfoto laten meewisselen met de gekozen variant.

     Broadcast hoort dit zelf te doen, maar op de productpagina komt dat
     niet altijd door (conflict met apps/custom code). Dit scriptje doet
     het alsnog: het leest de productdata, kijkt welke opties zijn
     aangeklikt, zoekt de bijbehorende variant op en zet diens foto
     actief. Staat de juiste foto al actief, dan gebeurt er niets.
     ------------------------------------------------------------------ */
  function initProductSection(section) {
    if (section.dataset.variantMediaSwap) return;

    var gallery = section.querySelector('product-images');
    var jsonEl = section.querySelector('[data-product-json]');
    if (!gallery || !jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }
    if (!product || !product.variants || !product.variants.length) return;

    section.dataset.variantMediaSwap = 'true';
    var sectionId = section.getAttribute('data-section-id');

    function selectedValues() {
      var values = [];
      var inputs = section.querySelectorAll('[data-single-option-selector]');

      Array.prototype.forEach.call(inputs, function (input) {
        var raw = input.getAttribute('data-index') || '';
        var index = parseInt(raw.replace('option', ''), 10);
        if (!index) return;
        if (input.type === 'radio' && !input.checked) return;
        values[index - 1] = input.value;
      });

      return values;
    }

    function findVariant(values) {
      if (!values.length) return null;

      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        var match = true;

        for (var j = 0; j < values.length; j++) {
          if (values[j] !== undefined && variant.options[j] !== values[j]) {
            match = false;
            break;
          }
        }

        if (match) return variant;
      }

      return null;
    }

    function showVariantMedia() {
      var variant = findVariant(selectedValues());
      if (!variant || !variant.featured_media) return;

      var mediaId = sectionId + '-' + variant.featured_media.id;
      if (gallery.getAttribute('data-active-media') === mediaId) return;

      var slides = section.querySelectorAll('.product__slide[data-media-id]');
      if (!slides.length) return;

      var exists = false;
      Array.prototype.forEach.call(slides, function (slide) {
        if (slide.getAttribute('data-media-id') === mediaId) exists = true;
      });
      if (!exists) return;

      gallery.setAttribute('data-active-media', mediaId);

      Array.prototype.forEach.call(slides, function (slide) {
        var isActive = slide.getAttribute('data-media-id') === mediaId;
        slide.classList.toggle('media--active', isActive);
        slide.classList.toggle('media--hidden', !isActive);
      });
    }

    var timer = null;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(showVariantMedia, 60);
    }

    section.addEventListener('change', schedule);
    section.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;
      if (event.target.closest('label, [data-popout-option]')) schedule();
    });
  }

  function initAllProductSections() {
    var sections = document.querySelectorAll('[data-section-type="product"]');
    Array.prototype.forEach.call(sections, initProductSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductSections);
  } else {
    initAllProductSections();
  }

  // Themabewerker: opnieuw koppelen als de sectie herladen wordt
  document.addEventListener('shopify:section:load', initAllProductSections);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* ------------------------------------------------------------------
   Sylnia Butik — Gratis Black Friday-cadeau

   - De klant ontgrendelt het cadeau zelf met de knop op de productpagina.
   - Pas als er een BETAALD product in het mandje komt, gaat het cadeau mee.
   - Maximaal 1 per bestelling. Shopify kent zelf geen maximum per regel.
     We vangen het op drie plekken af: in het verzoek naar Shopify, na
     afloop als vangnet, en via een DOM-bewaker voor de UpCart-drawer,
     die zijn eigen verbinding met Shopify gebruikt en daardoor niet door
     onze fetch-haak heen komt.
   - Gaat het laatste betaalde product eruit, dan verdwijnt het cadeau ook.

   Het cadeau is het product 'tajemniczy-prezent-black-friday' van 0,00 zl,
   alleen gepubliceerd in de Online Store (niet in Google/Facebook).
   De balk zelf staat in snippets/sylnia-gift.liquid.
   ------------------------------------------------------------------ */
(function () {
  var GIFT_VARIANT_ID = 59024600465791; // Tajemniczy Prezent Black Friday
  var STORAGE_KEY = 'sylnia_gift_unlocked';
  var GIFT_PROPERTY = { _sylnia_gift: 'black-friday' };

  var routes = (window.theme && window.theme.routes) || {};
  var ADD_URL = routes.cart_add_url || '/cart/add';
  var CHANGE_URL = routes.cart_change_url || '/cart/change';
  var CART_URL = routes.cart_url || '/cart';

  var busy = false; // true terwijl wij zelf het mandje aanpassen
  var timer = null;
  var lastWatchCheck = 0;

  function unlocked() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setUnlocked(value) {
    try {
      if (value) {
        localStorage.setItem(STORAGE_KEY, '1');
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      /* privacymodus: dan geldt het alleen voor deze pagina */
    }
  }

  function giftVariantId() {
    var el = document.querySelector('[data-sylnia-gift][data-gift-variant]');
    if (el) {
      var fromDom = parseInt(el.getAttribute('data-gift-variant'), 10);
      if (fromDom) return fromDom;
    }
    return GIFT_VARIANT_ID;
  }

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartAdd(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function isCartChange(url) {
    return /\/cart\/(change|update)(\.js)?(\?|$)/.test(url);
  }

  function isCartMutation(url) {
    return /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url);
  }

  function jsonPost(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().catch(function () {
        return null;
      });
    });
  }

  function getCart() {
    return fetch(CART_URL + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json();
    });
  }

  function giftLine(cart) {
    var id = giftVariantId();
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === id) {
        return { item: items[i], index: i + 1, key: items[i].key };
      }
    }
    return null;
  }

  function paidQuantity(cart) {
    var id = giftVariantId();
    var items = (cart && cart.items) || [];
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id !== id) total += items[i].quantity;
    }
    return total;
  }

  function addGift() {
    busy = true;
    return jsonPost(ADD_URL + '.js', {
      items: [{ id: giftVariantId(), quantity: 1, properties: GIFT_PROPERTY }]
    })
      .catch(function () {
        return null;
      })
      .then(function (result) {
        busy = false;
        return result;
      });
  }

  function changeGiftQuantity(line, quantity) {
    busy = true;
    return jsonPost(CHANGE_URL + '.js', { line: line, quantity: quantity })
      .catch(function () {
        return null;
      })
      .then(function (result) {
        busy = false;
        return result;
      });
  }

  /* ---------- aantal afvangen voordat het verzoek weggaat ---------- */

  function clampArgs(args) {
    var init = args[1] || {};
    var body = init.body;
    if (!body) return Promise.resolve(args);

    var giftId = giftVariantId();

    return getCart()
      .then(function (cart) {
        var line = giftLine(cart);
        if (!line) return args;

        if (typeof body === 'string') {
          var data;
          try {
            data = JSON.parse(body);
          } catch (e) {
            return args;
          }
          var touched = false;

          if (data.updates) {
            if (data.updates[giftId] > 1) {
              data.updates[giftId] = 1;
              touched = true;
            }
            if (data.updates[line.key] > 1) {
              data.updates[line.key] = 1;
              touched = true;
            }
          }

          var targetsGift =
            data.id === line.key ||
            String(data.id) === String(giftId) ||
            data.line === line.index;

          if (targetsGift && data.quantity > 1) {
            data.quantity = 1;
            touched = true;
          }

          if (!touched) return args;

          var newInit = {};
          for (var k in init) {
            if (Object.prototype.hasOwnProperty.call(init, k)) newInit[k] = init[k];
          }
          newInit.body = JSON.stringify(data);
          return [args[0], newInit];
        }

        if (typeof body.get === 'function' && typeof body.set === 'function') {
          var id = body.get('id');
          var lineNr = body.get('line');
          var qty = parseInt(body.get('quantity'), 10);
          var hits =
            String(id) === String(line.key) ||
            String(id) === String(giftId) ||
            String(lineNr) === String(line.index);

          if (hits && qty > 1) body.set('quantity', '1');
          return args;
        }

        return args;
      })
      .catch(function () {
        return args;
      });
  }

  function giftBeforeAdd() {
    if (!unlocked()) return Promise.resolve();
    return getCart()
      .then(function (cart) {
        if (giftLine(cart)) return null;
        return addGift();
      })
      .catch(function () {
        return null;
      });
  }

  /* Vangnet: nooit meer dan 1, en nooit alleen het cadeau in het mandje. */
  function enforce() {
    if (busy) return Promise.resolve();
    return getCart()
      .then(function (cart) {
        var line = giftLine(cart);
        var paid = paidQuantity(cart);

        if (line && paid === 0) {
          return changeGiftQuantity(line.index, 0).then(refreshCartUi);
        }
        if (line && line.item.quantity > 1) {
          return changeGiftQuantity(line.index, 1).then(refreshCartUi);
        }
        if (!line && paid > 0 && unlocked()) {
          return addGift().then(refreshCartUi);
        }
        return null;
      })
      .catch(function () {
        return null;
      });
  }

  function scheduleEnforce() {
    clearTimeout(timer);
    timer = setTimeout(enforce, 350);
  }

  function refreshCartUi() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {
      /* oudere browsers */
    }
    if (/^\/cart(\/|$)/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = urlOf(args[0]);

      if (!busy && isCartAdd(url) && unlocked()) {
        return giftBeforeAdd().then(function () {
          return originalFetch.apply(window, args).then(function (res) {
            scheduleEnforce();
            return res;
          });
        });
      }

      if (!busy && isCartChange(url)) {
        return clampArgs(args).then(function (safeArgs) {
          return originalFetch.apply(window, safeArgs).then(function (res) {
            scheduleEnforce();
            return res;
          });
        });
      }

      var request = originalFetch.apply(window, args);
      if (!busy && (isCartAdd(url) || isCartMutation(url))) {
        return request.then(function (res) {
          scheduleEnforce();
          return res;
        });
      }
      return request;
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (typeof url === 'string' && (isCartAdd(url) || isCartMutation(url))) {
        this.addEventListener('load', function () {
          if (!busy) scheduleEnforce();
        });
      }
    } catch (e) {
      /* niets */
    }
    return originalOpen.apply(this, arguments);
  };

  /* UpCart praat buiten onze fetch-haak om met Shopify. We kunnen zijn
     verzoeken dus niet onderscheppen, maar we zien de drawer wel bewegen.
     Verandert daar iets, dan controleren we het mandje opnieuw. De
     afkoeltijd voorkomt dat dit bij elke animatie afgaat. */
  function watchCartUi() {
    if (!window.MutationObserver || !document.body) return;

    var observer = new MutationObserver(function () {
      if (busy) return;
      var now = Date.now();
      if (now - lastWatchCheck < 1500) return;
      lastWatchCheck = now;
      scheduleEnforce();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function paint(root, isUnlocked) {
    var offer = root.querySelector('[data-gift-offer]');
    var done = root.querySelector('[data-gift-done]');
    if (!offer || !done) return;
    offer.hidden = isUnlocked;
    done.hidden = !isUnlocked;
    root.setAttribute('data-state', isUnlocked ? 'unlocked' : 'locked');
  }

  function paintAll(isUnlocked) {
    var bars = document.querySelectorAll('[data-sylnia-gift]');
    Array.prototype.forEach.call(bars, function (bar) {
      paint(bar, isUnlocked);
    });
  }

  function bind(root) {
    if (root.dataset.sylniaGiftReady) return;
    root.dataset.sylniaGiftReady = 'true';

    paint(root, unlocked());

    var trigger = root.querySelector('[data-gift-unlock]');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      setUnlocked(true);
      paintAll(true);

      getCart()
        .then(function (cart) {
          if (paidQuantity(cart) > 0 && !giftLine(cart)) {
            return addGift().then(refreshCartUi);
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    });
  }

  function initGift() {
    var bars = document.querySelectorAll('[data-sylnia-gift]');
    Array.prototype.forEach.call(bars, bind);
    scheduleEnforce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGift();
      watchCartUi();
    });
  } else {
    initGift();
    watchCartUi();
  }

  document.addEventListener('shopify:section:load', initGift);

  /* Testen in de browserconsole:
     SylniaGift.reset()  -> alsof de klant nog niet geklikt heeft
     SylniaGift.unlock() -> alsof de klant wel geklikt heeft */
  window.SylniaGift = {
    unlock: function () {
      setUnlocked(true);
      paintAll(true);
      return enforce();
    },
    reset: function () {
      setUnlocked(false);
      paintAll(false);
      return enforce();
    },
    isUnlocked: unlocked,
    enforce: enforce
  };
})();
